import { Component, Input, OnInit, TemplateRef } from '@angular/core';
import { PropositionService } from '../_services/proposition.service';
import { TokenStorageService } from '../_services/token-storage.service';

@Component({
  selector: 'app-propositions',
  templateUrl: './propositions.component.html',
  styleUrls: ['./propositions.component.scss']
})

export class PropositionsComponent implements OnInit {
  propositionList: any = [];

  constructor(
    private tokenStorage: TokenStorageService,
    private proposition: PropositionService,
  ) { }

  ngOnInit(): void {
    const token = this.tokenStorage.getToken() || "";

    this.proposition.getPropositionsList$(token).subscribe({
      next: (data:any) => {
        console.log("Data --> ", data);
        this.propositionList = data;
        console.log("propositionList ", this.propositionList);
      },
      error: (err: any) => {
        console.log("Something went wrong: ", err)
      }
    })
  }
}
